import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Menu } from "lucide-react";
import Sidebar from "../components/Sidebar";
import MobileSidebar from "../components/MobileSidebar";
import ScrollToTop from "../components/ScrollToTop";

const VendorShell = ({
  isMobile,
  isSidebarCollapsed,
  setIsSidebarCollapsed,
  isMobileMenuOpen,
  setIsMobileMenuOpen,
}) => {
  const location = useLocation();
  const isStoreWorkspace = location.pathname === "/my-store";

  return (
    <div className="relative">
      <div className="flex overflow-hidden h-screen">
        {!isMobile && !isStoreWorkspace && (
          <Sidebar onToggleCollapse={setIsSidebarCollapsed} />
        )}

        <div
          className={`flex-1 transition-all duration-300 ease-in-out ${
            isStoreWorkspace ? "overflow-hidden" : "overflow-auto"
          } ${
            !isMobile && !isStoreWorkspace
              ? isSidebarCollapsed
                ? "ml-24"
                : "ml-72"
              : "ml-0"
          }`}
        >
          {isMobile && !isStoreWorkspace && (
            <button
              onClick={() => setIsMobileMenuOpen(true)}
              className="fixed top-4 left-4 z-40 p-2 bg-white rounded-md shadow-md"
            >
              <Menu className="w-6 h-6" />
            </button>
          )}

          <AnimatePresence>
            {isMobile && !isStoreWorkspace && (
              <MobileSidebar
                isOpen={isMobileMenuOpen}
                onClose={() => setIsMobileMenuOpen(false)}
              />
            )}
          </AnimatePresence>

          <ScrollToTop />
          <Outlet key={location.pathname} />
        </div>
      </div>
    </div>
  );
};

export default VendorShell;
